module.exports = __webpack_public_path__ + "src/app/_content/imgs/icons/tyre.png?7e84c7de4858e4ac0819fd89f95365d1";